import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { OximeterState } from "../../ProSimulator/OximeterSimulator";
import { colors } from "../../Style";
import { ALARM_CODE, ALARM_SEVERITY } from "../../ProSimulator/Alarm";
import { getHighestSeverityAlarm } from "../../ProSimulator/Alarm";
import { blink } from "../../Style";
import { translate, Translate } from "react-i18nify";
import { roundToNearest } from "../../Utils";
export const O2Component = (props) => {
  let color = props.color;
  let name = props.name;
  let unit = props.unit;
  let error = props.error;
  let value = props.value;
  let isManual = props.isManual;

  const [flowAlarm, setFlowAlarm] = useState();

  useEffect(() => {
    let flowError = getHighestSeverityAlarm(props.pro?.alarms, [
      ALARM_CODE.O2_FLOW_ERROR,
      ALARM_CODE.NO_FLOW,
    ]);

    if (flowError != 0 && flowError != undefined) {
      setFlowAlarm(flowError);
    } else {
      setFlowAlarm(null);
    }
  }, [props.pro?.alarms]);

  const getAlarmColor = (error) => {
    if(error == null)
      return "white"
    switch (error.severity){
      case ALARM_SEVERITY.CRITICAL_INFO:
      case ALARM_SEVERITY.CRITICAL_ALARM:
        return colors().COLORS_ALARM_HIGH
      case ALARM_SEVERITY.WARNING:
      case ALARM_SEVERITY.ALARM:
          return colors().COLORS_ALARM_MEDIUM
      case ALARM_SEVERITY.INFO:
        return colors().COLORS_ALARM_LOW
      default:
        return "white";
    }
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
      name="outerBox"
    >
      {
        //NO VITALS DISPLAY--------------------------------------------------------------------------------------------------------------------------------------------
        !props.showVital ? 
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "end",
          }}
          name="comonmand"
        >
          <Box
          sx={{
            width: "100%",
            height: "23.5%",
            display: "flex",
            justifyContent: "center",
          }}
          align="center"
          name="innerBox"
          >
              <Typography
                variant="h5"
                sx={{
                  color: colors().COLORS_ALARM_LOW,
                  display: props.isManual ? "flex" : "none",
                  fontWeight: "bold",
                }}
                name="typo"
              >
                <Translate value="ManualMode" />
              </Typography>
          </Box>
        </Box>
      : 
        //SHOW VITALS DISPLAY--------------------------------------------------------------------------------------------------------------------------------------------
        <>
        <Box
          sx={{
            width: "100%",
            height: "16%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <Typography sx={{ color: colors().TEXT_COLOR }} variant="h6">
            {name}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              position: "absolute",
              right: "100px",
              top: "20px",
              color: "gray",
            }}
          >
            {unit}
          </Typography>
        </Box>
        <Box
          sx={{
            width: "75%",
            height: "35%",
            display: "flex",
            flexDirection: "row",
            border: "2px solid " + color,
            borderRadius: "25px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              color:
                props.pro?.oxygenOutput > 1500 ? colors().COLORS_ALARM_LOW : colors().TEXT_COLOR,
            }}
          >
            {props.pro?.oxygenOutput > 1500
              ? "15.0+"
              : flowAlarm?.alarmCode === ALARM_CODE.NO_FLOW && !isManual
              ? "0.0"
              : value < 200 && value !== 0
              ? (value / 100).toFixed(props.decimalPoints ?? 1)
              : (value / 100).toFixed(1)
            }
          </Typography>
        </Box>
        <Box
          sx={{
            width: "2px",
            height: "8%",
            display: "flex",
            flexDirection: "row",
            background: color,
            justifyContent: "center",
          }}
        />
        <Box
          sx={{
            width: "100%",
            height: "15%",
            display: "flex",
            flexDirection: "row",
            border: "2px solid " + color,
            borderRadius: "20px",
            justifyContent: props.isManual ? "center" : "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              ml: 2,
              color: colors().TEXT_COLOR,
              display: props.isManual ? "none" : "flex",
            }}
          >
            {(props?.min/100)}
          </Typography>
          <Typography
            variant="h5"
            sx={{
              color: colors().COLORS_ALARM_LOW,
              display: props.isManual ? "flex" : "none",
              fontWeight: "bold",
            }}
          >
            <Translate value="ManualMode" />
          </Typography>
          <Typography
            variant="h5"
            sx={{
              mr: 2,
              color: colors().TEXT_COLOR,
              display: props.isManual ? "none" : "flex",
            }}
          >
            {(props?.max/100)}
          </Typography>
        </Box>
        <Box
          sx={{
            width: "100%",
            height: "18%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              display:
                flowAlarm && props.pro?.oxygenOutput <= 1500 ? "block" : "none",
              color: getAlarmColor(flowAlarm),
              animation: `${blink} 0.5s infinite`,
              fontWeight: "bold",
            }}
          >
            {flowAlarm == null || isManual ? "" : translate(flowAlarm.name)}
          </Typography>
          <Typography
            variant="h5"
            sx={{
              display:
                props.pro?.oxygenOutput > 1500 && isManual ? "block" : "none",
              color: colors().COLORS_ALARM_LOW,
              fontWeight: "bold",
            }}
          >
            Flow inaccurate
          </Typography>
        </Box>
        </>
      }
    </Box>
  );
};